import { t } from "./i18n";

export const systemVarsPool = [
  {
    value: "SystemSessionID",
    label: "SystemSessionID",
    tip: t("当前会话ID"),
  },
  {
    value: "SystemClientUserID",
    label: "SystemClientUserID",
    tip: t("请求的用户ID"),
  },
  {
    value: "SystemCustomerServiceID",
    label: "SystemCustomerServiceID",
    tip: t("客服号ID"),
  },
  {
    value: "SystemChannelType",
    label: "SystemChannelType",
    tip: t("渠道类型"),
  },
  {
    value: "SystemFlowTriggerRewriteQuery",
    label: "SystemFlowTriggerRewriteQuery",
    tip: t("触发该任务流的对话内容改写结果"),
  },
  {
    value: "SystemFlowID",
    label: "SystemFlowID",
    tip: t("任务流 ID"),
  },
];
